/* eslint "import/no-mutable-exports": "off" */

const educationTypes = {
  POST_GRADUATE: { type: 'POST_GRADUATE', title: 'education.post_graduate', intl: true },
  UNIVERSITY: { type: 'UNIVERSITY', title: 'education.university', intl: true },
  POLYTECHNIC: { type: 'POLYTECHNIC', title: 'education.polytechnic', intl: true },
  HIGH: { type: 'HIGH', title: 'education.high', intl: true },
  PRELIMINARY: { type: 'PRELIMINARY', title: 'education.preliminary', intl: true },
  VOCATIONAL: { type: 'VOCATIONAL', title: 'education.vocational', intl: true },
  MIDDLE: { type: 'MIDDLE', title: 'education.middle', intl: true },
  HIGH_SECONDARY: { type: 'HIGH_SECONDARY', title: 'education.high_secondary', intl: true },
  SECONDARY: { type: 'SECONDARY', title: 'education.secondary', intl: true },
  PRIMARY: { type: 'PRIMARY', title: 'education.primary', intl: true },
  OTHER_MISSING: { type: 'OTHER_MISSING', title: 'education.other', intl: true },
  SCHOOL: { type: 'SCHOOL', title: 'education.school', intl: true },
  SCHOOL_GRADUATE: { type: 'SCHOOL_GRADUATE', title: 'education.school_graduate', intl: true },
  SCHOOL_HIGH: { type: 'SCHOOL_HIGH', title: 'education.school_high', intl: true },
  SCHOOL_TRADE: { type: 'SCHOOL_TRADE', title: 'education.school_trade', intl: true },
  TAFE: { type: 'TAFE', title: 'education.tafe', intl: true },
};

const eeTypes = [
  educationTypes.UNIVERSITY,
  educationTypes.POLYTECHNIC,
  educationTypes.VOCATIONAL,
  educationTypes.SECONDARY,
  educationTypes.MIDDLE,
  educationTypes.PRIMARY,
];

const lvTypes = [
  educationTypes.UNIVERSITY,
  educationTypes.POLYTECHNIC,
  educationTypes.HIGH_SECONDARY,
  educationTypes.VOCATIONAL,
  educationTypes.PRIMARY,
];

const fiTypes = [
  educationTypes.UNIVERSITY,
  educationTypes.POLYTECHNIC,
  educationTypes.HIGH,
  educationTypes.VOCATIONAL,
  educationTypes.MIDDLE,
];

const mxTypes = [
  educationTypes.POST_GRADUATE,
  educationTypes.UNIVERSITY,
  educationTypes.POLYTECHNIC,
  educationTypes.SECONDARY,
  educationTypes.PRIMARY,
];

const esTypes = [
  educationTypes.UNIVERSITY,
  educationTypes.POLYTECHNIC,
  educationTypes.SECONDARY,
  educationTypes.PRIMARY,
  educationTypes.OTHER_MISSING,
];

const auTypes = [
  educationTypes.SCHOOL,
  educationTypes.SCHOOL_HIGH,
  educationTypes.SCHOOL_TRADE,
  educationTypes.TAFE,
  educationTypes.SCHOOL_GRADUATE,
];

const ltTypes = [
  educationTypes.UNIVERSITY,
  educationTypes.POLYTECHNIC,
  educationTypes.VOCATIONAL,
  educationTypes.HIGH,
  educationTypes.MIDDLE,
  educationTypes.PRELIMINARY,
];

let data = [];

switch (COUNTRY) {
  case 'LV':
    data = data.concat(lvTypes);
    break;
  case 'FI':
    data = data.concat(fiTypes);
    break;
  case 'MX':
    data = data.concat(mxTypes);
    break;
  case 'ES':
    data = data.concat(esTypes);
    break;
  case 'AU':
    data = data.concat(auTypes);
    break;
  case 'LT':
    data = data.concat(ltTypes);
    break;

  default:
    data = data.concat(eeTypes);
}

export default data;
